import { Tag } from 'common/OptionSelect/Tag'
import { ReactNode } from 'react'
import Styles from './CalendarEventCard.module.scss'
import { useCurrentBrandPlan } from 'hooks/queries/brandPlans/useCurrentBrandPlan'
import { PostStatus, StatusPillV2 } from './StatusPillV2'
import cx from 'classnames'

export interface StatusPillProps {
  status: ReactNode
  postStatus?: PostStatus
  color: string
  fontColor: string
  testId: string
  size?: 'xs' | 'sm' | 'md'
}

export const StatusPill = ({ status, postStatus, color, fontColor, testId, size = 'md' }: StatusPillProps) => {
  const { data: brandPlan } = useCurrentBrandPlan()
  const isV2 = brandPlan?.has_content_strategies

  if (isV2 && postStatus) {
    return (
      <div className={cx(Styles.statusCornerContainer, Styles.isV2)}>
        <StatusPillV2 label={status} status={postStatus} testId={testId} size={size} />
      </div>
    )
  }

  return (
    <div className={Styles.statusCornerContainer}>
      <div className={Styles.statusPill} data-testid={testId}>
        <Tag size={size} color={color} fontColor={fontColor}>
          {status}
        </Tag>
      </div>
    </div>
  )
}
